import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamEclipticLatitude = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Union",
			d: "M11.6455 2.3153C11.8393 2.11886 12.1559 2.11664 12.3525 2.31042L15.5566 5.46862C15.7532 5.66246 15.7553 5.97899 15.5615 6.17566C15.3676 6.37221 15.0511 6.37533 14.8544 6.18152L12.5097 3.86999L12.5644 11.5614L19.997 11.4999C20.2732 11.4976 20.4986 11.7198 20.5009 11.996C20.5032 12.272 20.2818 12.4974 20.0058 12.4999L12.5722 12.5614L12.6279 20.2577L14.9394 17.913C15.1333 17.7165 15.4498 17.7143 15.6464 17.9081C15.8431 18.1019 15.8452 18.4184 15.6513 18.6151L12.4931 21.8202C12.2994 22.0167 11.9827 22.0186 11.7861 21.8251L8.581 18.6659C8.38461 18.472 8.38236 18.1554 8.57612 17.9589C8.76996 17.7623 9.08652 17.7602 9.28315 17.954L11.6279 20.2655L11.5722 12.5702L4.14057 12.6327C3.86459 12.6348 3.63898 12.4126 3.63667 12.1366C3.63458 11.8606 3.85676 11.635 4.13276 11.6327L11.5644 11.5702L11.5097 3.87683L9.19917 6.22155C9.00549 6.41804 8.68884 6.42075 8.49214 6.22741C8.29559 6.03368 8.29278 5.71707 8.48628 5.52038L11.6455 2.3153Z",
			fill: "var(--fill-0, #DFCBF5)",
			fillOpacity: .7
		})
	})
});
export default SvgParamEclipticLatitude;
